@import "../../containers/styles.module.scss";

.container {
  padding-bottom: 4rem;
  box-sizing: content-box;

  &__header {
    h2 {
      margin-bottom: 24px;
    }
  }

  &__form {
    width: unset;

    &_container {
      padding-top: 20px;
    }

    &_group {
      margin-bottom: 40px;

      &:last-of-type {
        margin-bottom: unset;
      }

      h3 {
        font-size: 20px;
        margin-bottom: 0;
      }

      div {
        margin-top: 12px;
        letter-spacing: 0.3px;
      }

      button {
        margin-top: 16px;
      }
    }
  }

  &__buttons {
    margin-top: 16px;
  }
}
